/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bound } from './bound';

/**
 * 旅程情報
 */
export interface GetOrderResponseDataAir {
  /**
   * 旅程区分<br/> domestic：日本国内単独旅程<br/> international：国際旅程
   */
  tripType?: GetOrderResponseDataAir.TripTypeEnum;
  /**
   * 欠航有無<br/> セグメントステータスがUNであるセグメントが存在する場合にtrue
   */
  isContainedCancelledFlight?: boolean;
  /**
   * 欠航となったNHグループ便名NHグループ運航の有無<br/> セグメントステータスがUNであるNHグループ便名NHグループ運航の便が存在する場合にtrue
   */
  isContainedCancelledNhFlight?: boolean;
  /**
   * 一部搭乗済みであるか<br/> クーポンステータスが使用済みであるｅチケットが存在する場合にtrue
   */
  isPartiallyBoarded?: boolean;
  /**
   * NHグループ便名セグメント有無<br/> NHグループ便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupMarketingSegment?: boolean;
  /**
   * NHグループ運航セグメント有無<br/> NHグループ運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedNhGroupOperatingSegment?: boolean;
  /**
   * 他社便名セグメント有無<br/> 他社便名のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierMarketingSegment?: boolean;
  /**
   * 他社運航セグメント有無<br/> 他社運航のセグメントが旅程内に含まれる場合にtrue
   */
  isContainedOtherCarrierOperatingSegment?: boolean;
  /**
   * 空席待ちセグメント有無<br/> セグメントステータスが空席待ち(設定ファイルに定義)であるセグメントが存在する場合にtrue
   */
  isContainedWaitlistedSegment?: boolean;
  /**
   * スケジュールチェンジセグメント有無<br/> スケジュールチェンジが発生しているかがtrueであるセグメントが存在する場合にtrue
   */
  isContainedScheduleChangedFlight?: boolean;
  /**
   * 最上位キャビンクラス<br/> 国際旅程で日本発着国際線がある場合は、そのセグメントのうち最上位のキャビンクラス、そうでない場合は全セグメントのキャビンクラスの内、最上位のものを返却する<br/> eco：エコノミー<br/> ecoPremium：プレミアムエコノミー<br/> business：ビジネス<br/> first：ファースト
   */
  highestCabinClass?: GetOrderResponseDataAir.HighestCabinClassEnum;
  /**
   * バウンドリスト<br/> ※以下のいずれかの条件に該当するセグメントは返却しない<br/> 1.ステータスがパッシブセグメント(対象となるステータスは設定ファイルに定義)<br/> 2.ステータスがゴーストセグメント(対象となるステータスは設定ファイルに定義)<br/> 3.キャリアコード未指定(キャリアコード＝YYとしてDxAPIから返却)のOPEN便<br/> 4.Informative Segment<br/> 5.フリーテキストに\"\"WEB//@IGNORE\"\"を含むRMエレメントがリレートしているセグメント<br/> ※アップグレード空席待ちのセグメント(UPG-HL便と記載)がある場合、以下の通りに処理を行い、アップグレード前のセグメント(UPG-HK便と記載)とマージして返却する<br/> 1.SSR FQTU/STAR/UPGD・SK PUPGから、FlightIDを探し、UPG-HL便を特定する<br/> 2.UPG-HL便と出発日・販売キャリアコード・便番号が同一でステータスがHKのFlightIDを探し、UPG-HK便を特定する<br/> UPG-HK便を特定出来なかった場合は処理3以降を実施しない<br/> 3.UPG-HK便のセグ情報をUPG-HL便のセグ情報に対して上書く。<br/> ーーーーーーーーー<br/> 【上書きしない項目】<br/> connectionTime<br/> departureDaysDifference<br/> arrivalDaysDifference<br/> ーーーーーーーーー<br/> 4.UPG-HK便のセグ情報及びBoundは返却しない<br/> ※メジャースケジュールチェンジが発生しているバウンドが存在する場合、そのバウンドのoriginalFlights(振替前セグメント情報リスト)の内、セグメントステータスがUNのセグメントのみで構成されるバウンド情報を作成し、当該バウンドの直前に挿入して返却する。
   */
  bounds?: Array<Bound>;
  /**
   * ルフトハンザサイトで座席指定可能なセグメント有無<br/> 以下の条件を満たす場合、trueを返却する<br/> 1 IATAエリアを跨いでいる<br/> 2 LH運航である<br/> 3 キャビンクラスが、設定ファイルに定義したルフトハンザ便のdeeplink対象キャビンクラスである
   */
  isContainedSeatRequestableSegmentInLHSite?: boolean;
  /**
   * 暗号化済みLHサイト連携パラメータ<br/> ルフトハンザサイトで座席指定可能なセグメント有無がtrueの場合、返却する。<br/> ※G03_共通処理（514_暗号化）を用いてAES形式にて暗号化を行う。<br/> ※暗号化キーは設定ファイルにて管理する。
   */
  encryptDataForLHSite?: string;
  /**
   * 香港発着セグメントを含むか<br/> 出発地または到着地が香港であるセグメントが旅程に含まれる場合にtrue
   */
  isContainedHongKongSegment?: boolean;
  /**
   * 中国発(香港・台湾・マカオ含まず)または中国経由便が含まれるかどうか<br/> 旅程中に中国発(香港・台湾・マカオ含まず)セグメント、または中国経由便(同一セグメント内での中国国内での途中降機)を含む場合true
   */
  isContainedChinaSegmentIncludesStops?: boolean;
  /**
   * アイきっぷ運賃有無<br/> Fare Basisの7桁目が設定ファイルに定義したアイきっぷ運賃Fare basisと合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedRemoteIslandFare?: boolean;
  /**
   * 障がい者割引運賃有無<br/> Ticket disignator(ICが付与される)が設定ファイルに定義したTicket disignatorと合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedDisabilityDiscountFare?: boolean;
  /**
   * 年齢制限のある割引運賃有無<br/> Fare basisの7桁目が設定ファイルに定義したスマートシニア空割Fare basis、スマートU25Fare basisのいずれかと合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedAgeLimitedFares?: boolean;
  /**
   * ビジネスきっぷ運賃有無<br/> Fare basisの7桁目が設定ファイルに定義したビジネスきっぷ運賃Fare basis、プレミアムビジネスきっぷFare basisのいずれかと合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedBusniessKippuFares?: boolean;
  /**
   * 株主優待運賃有無<br/> Fare basisの7桁目が設定ファイルに定義した株主優待運賃Fare basisに合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedShareholdersBenefitDiscountFare?: boolean;
  /**
   * 後日回収型株主優待運賃有無<br/> Fare basisの7桁目が設定ファイルに定義した後日回収型株主優待運賃Fare basisに合致するセグメントが旅程に含まれる場合にtrue
   */
  isContainedShareholdersBenefitDiscountFareByPostCollection?: boolean;
  /**
   * 包括旅行運賃有無<br/> PNR作成オフィスコードの4文字目から8文字目までの文字列が、設定ファイルの「包括旅行運賃(IIT)を販売するオフィスレンジ」に含まれる。
   */
  isContainedInclusiveTourFare?: boolean;
  /**
   * 国会議員クーポン支払有無<br/> 以下の全ての条件に該当する場合にtrue<br/> 1.ドキュメント種別が航空券である<br/> 2.航空券支払情報IDがHRDIETまたはHCDIETである
   */
  isContainedLawmakerCouponPayment?: boolean;
  /**
   * アップグレード済である日本国内線のセグメント有無<br/> アップグレード区分が空欄でない日本国内線のセグメントが含まれる場合true
   */
  isContainedUpgradedJapanDomesticSegment?: boolean;
  /**
   * 全バウンドがNo Showとなったセグメントのみのバウンドかどうか<br/> クーポン情報のNoShowインジケータがtrueである航空券情報のみ存在する場合にtrue
   */
  isAllBoundsNoShow?: boolean;
  /**
   * 日本国内線のセグメントが含まれるか<br/> 日本国内線のセグメントが含まれる場合true
   */
  isContainedJapanDomesticSegment?: boolean;
  /**
   * Dynamic Waiver Refund対象便有無<br/> Waiverコードが存在する場合true<br/> ※\"cancelAndRefund\"を格納したtargetActionと、予約番号を指定して呼び出したDxAPI(GET /purchase/order-eligibilities)で、Dynamic Waiver Refund対象便の場合
   */
  isContainedDynamicWaiverRefundFlight?: boolean;
  /**
   * Dynamic Waiver Change対象便有無<br/> Waiverコードが存在する場合true<br/> ※予約番号を指定して呼び出したDxAPI(GET /purchase/orders)の「orderEligibilities > change」の「waiverCodes」で、Dynamic Waiver Change対象便の場合
   */
  isContainedDynamicWaiverChangeFlight?: boolean;
  /**
   * 全バウンドがバウンド毎不可条件に該当するかどうか<br/> バウンド毎不可条件に該当するバウンドかどうかが全バウンドでtrueの場合true
   */
  isAllBoundsNotEligible?: boolean;
  /**
   * Change Journey不可Fare basisの便が含まれるか否か<br/> Change Journey不可Fare basisの便が含まれる場合true<br/> ※ASWDB(マスタ)のChange Journey不可Fare basisパターンに該当する場合
   */
  isContainedChangeJourneyProtectedFareBasisFlight?: boolean;
  /**
   * 搭乗可能なINF数を超えたセグメント有無<br/> SSRステータスがNOであるSSR INFTが、旅程内の未出発の便に存在する場合にtrue
   */
  isContainedInfantQuotaShortageSegment?: boolean;
  /**
   * イレギュラー対象便を含むか<br/> イレギュラー対象便を含む場合にtrue<br/> イレギュラー対象便はセグメントステータスに下記が含まれるか否かで判別する<br/> KK/HN/NA/TN/UU/UC/US/NO/HX/IW/TK/TL/UN(設定ファイルに定義)
   */
  isContainedIrregularFlights?: boolean;
}
export namespace GetOrderResponseDataAir {
  export type TripTypeEnum = 'domestic' | 'international';
  export const TripTypeEnum = {
    Domestic: 'domestic' as TripTypeEnum,
    International: 'international' as TripTypeEnum,
  };
  export type HighestCabinClassEnum = 'eco' | 'ecoPremium' | 'business' | 'first';
  export const HighestCabinClassEnum = {
    Eco: 'eco' as HighestCabinClassEnum,
    EcoPremium: 'ecoPremium' as HighestCabinClassEnum,
    Business: 'business' as HighestCabinClassEnum,
    First: 'first' as HighestCabinClassEnum,
  };
}
